<template>
  <div>
    <section class="d-block" name="DokumenKelayakan" v-can="'kontrak/detail/dokumenKajianKelayakan/read'">
      <div class="row align-items-center justify-content-between">
        <div class="col-auto mb-1">
          <h4 class="card-title mb-0">
            Dokumen Kajian Kelayakan
            <button
              type="button"
              @click="showModalDokumenKelayakan('add')"
              class="btn btn-primary btn-block-mobile"
              v-can="'kontrak/detail/dokumenKajianKelayakan/create'">
              Tambah Dokumen Kajian Kelayakan
            </button>
          </h4>
        </div>

        <div class="col-12 col-sm-4 mb-1">
          <div class="input-group form-search-rounded">
            <input
              class="form-control py-2 border-right-0 border"
              type="search"
              v-model="dokumenKelayakanQuery"
              placeholder="Cari dokumen kelayakan.."
            />
            <span class="input-group-append">
              <div class="input-group-text bg-transparent">
                <a href="#" class="text-blue"
                  ><i class="fa fa-search"></i
                ></a>
              </div>
            </span>
          </div>
        </div>
      </div>

      <div class="table-responsive no-sort w-100">
        <table class="table tabel-status-document w-100">
          <thead>
            <tr>
              <th>Nama</th>
              <th>Nomor</th>
              <th><i class="feather icon-download-cloud fa-l"></i> File</th>
              <th>Tanggal</th>
              <th class="w10">Aksi</th>
            </tr>
          </thead>
          <tbody v-if="dokumenKelayakanDatas.length > 0">
            <tr v-for="data in dokumenKelayakanDatas" :key="data.id">
              <td>{{ data.name }}</td>
              <td>{{ data.number }}</td>
              <td>
                <div v-if="data.file == null">-</div>
                <div v-else>
                  <p class="mb-0">
                    <a @click="pdfViewer(data.file.url)" href="javascript:;">
                      • File [Lihat Detail]
                    </a>
                  </p>
                </div>
              </td>
              <td>{{ data.col_date }}</td>
              <td>
                <div class="btn-action-block">
                  <button
                    type="button"
                    class="btn btn-icon-small btn-warning-trans waves-effect waves-light"
                    @click="dokumenKelayakanDetail = data, showModalDokumenKelayakan('edit');"
                    v-can="'kontrak/detail/dokumenKajianKelayakan/update'">
                    <i class="fa fa-pencil"></i>
                  </button>
                  &emsp;
                  <button
                    type="button"
                    class="btn btn-icon-small btn-danger-trans waves-effect waves-light"
                    @click="destroyDokumenKelayakan(data.id)"
                    v-can="'kontrak/detail/dokumenKajianKelayakan/delete'">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="6" class="text-center">Tidak ada data.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr class="my-2" />
    </section>

    <div
      class="modal fade text-left"
      id="modalDokumenKelayakan"
      role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header modal-primary white">
            <h5 class="modal-title" id="myModalLabel160">
              {{ dokumenKelayakanDetail.id ? 'Edit' : 'Tambah' }} Dokumen Kajian Kelayakan
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ValidationObserver ref="dokumenKelayakanFormObserver">
              <div class="form-group">
                <ValidationProvider
                  name="Nama"
                  rules="required"
                  v-slot="{ errors }">
                  <label for="">Nama</label>
                  <select
                    v-model="dokumenKelayakanForm.name"
                    class="form-control"
                    placeholder="Masukan nama"
                    :class="Boolean(errors[0]) ? 'is-invalid' : ''">
                    <option value="">Pilih nama dokumen</option>
                    <option value="Kajian Kelayakan Project (KKP)">Kajian Kelayakan Project (KKP)</option>
                    <option value="Kajian Kelayakan Finansial (KKF)">Kajian Kelayakan Finansial (KKF)</option>
                    <option value="Kajian Kelayakan Operasi (KKO)">Kajian Kelayakan Operasi (KKO)</option>
                  </select>
                  <small>{{ errors[0] }} </small>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <ValidationProvider
                  name="Nomor"
                  rules="required"
                  v-slot="{ errors }">
                  <label for="">Nomor</label>
                  <input
                    type="text"
                    v-model="dokumenKelayakanForm.number"
                    class="form-control"
                    placeholder="Masukan nomor"
                    :class="Boolean(errors[0]) ? 'is-invalid' : ''"
                    aria-describedby="helpId"
                  />
                  <small>{{ errors[0] }} </small>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <ValidationProvider
                  name="Tanggal"
                  rules="required"
                  v-slot="{ errors }">
                  <label for="">Tanggal</label>
                  <div class="position-relative has-icon-right">
                    <date-picker
                      v-model="dokumenKelayakanForm.date"
                      format="DD/MM/YYYY"
                      type="date"
                      :input-class="
                        Boolean(errors[0])
                          ? 'form-control is-invalid no-x'
                          : 'form-control'
                      "
                      value-type="YYYY-MM-DD"
                      placeholder="Masukkan tanggal"
                      style="width: 100%" />
                  </div>
                  <small>{{ errors[0] }} </small>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <label for="filter_by">Upload File</label>
                <vue-dropzone
                  ref="dokumenKelayakanDropzone"
                  id="dokumenKelayakanDropzone"
                  :duplicateCheck="true"
                  @vdropzone-files-added="onDokumenKelayakanFilesAdded"
                  @vdropzone-removed-file="onDokumenKelayakanFilesRemoved"
                  :options="dokumenKelayakanDropzoneOptions"
                >
                </vue-dropzone>
                <button
                  v-if="dokumenKelayakanDetail.file"
                  @click="removeAllDokumenKelayakanFile"
                  class="btn btn-danger"
                  style="margin-top: 10px">
                  Reset File
                </button>
                <ValidationProvider name="Dokumen" v-slot="{ errors }">
                  <input type="hidden" v-model="dokumenKelayakanForm.files" />
                  <p style="color: #ea5455">{{ errors[0] }}</p>
                </ValidationProvider>
              </div>
            </ValidationObserver>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-primary"
              data-dismiss="modal">
              Tutup
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="saveDokumenKelayakan()"
              :disabled="loading">
              <i v-if="loading" class="fa fa-spinner fa-spin"></i>
              <span v-if="!loading">Simpan</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import ld from "lodash";

export default {
  data() {
    return {
      dokumenKelayakans: [],
      dokumenKelayakanDetail: {
        id_kontrak: this.$route.params.id,
        name: '',
        number: '',
        date: '',
        files: [],
        deletedFile: [],
      },
      dokumenKelayakanQuery: "",
      dokumenKelayakanForm: {
        name: '',
        number: '',
        date: '',
        files: []
      },
      dokumenKelayakanDropzoneOptions: {
        url: this.$baseUrl + "/kontrak/progress",
        thumbnailWidth: 150,
        acceptedFiles: ".doc,.docx,application/msword,.pdf",
        autoProcessQueue: false,
        addRemoveLinks: true,
        uploadMultiple: false,
        headers: { Authorization: "Bearer " + this.$store.state.token },
        paramName: "image",
        maxFilesize: 10000,
        maxFiles: 1,
        init: function () {
          this.on("error", function (file, message) {
            alert(message);
            this.removeFile(file);
          });
        },
      },
      loading: false,
    }
  },
  computed: {
    dokumenKelayakanDatas: function() {
      let _ = this
      return _.dokumenKelayakans.filter(function( x ) {
        return x.number.toLowerCase().indexOf(_.dokumenKelayakanQuery.toLowerCase()) >= 0
      });
    }
  },
  methods: {
    getDokumenKelayakan() {
      let _ = this
      _.axios.get("v2/document-studies?id_kontrak=" + _.$route.params.id)
        .then((resp) => {
          _.dokumenKelayakans = resp.data.data;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    showModalDokumenKelayakan(type) {
      let _ = this;
      _.removeAllDokumenKelayakanFile();
      if (type == "edit") {
        _.dokumenKelayakanForm = {
          id: _.dokumenKelayakanDetail.id,
          id_kontrak: _.dokumenKelayakanDetail.id_kontrak,
          name: _.dokumenKelayakanDetail.name,
          number: _.dokumenKelayakanDetail.number,
          date: _.dokumenKelayakanDetail.date,
          files: [],
          deletedFile: [],
        };
        if (_.dokumenKelayakanDetail.file) {
          // _.dokumenKelayakanDetail.files.forEach(function (el) {
            let file = { size: 10240, name: _.dokumenKelayakanDetail.file.name, type: "application/word" };
            let url = _.dokumenKelayakanDetail.file.url;
            _.$refs.dokumenKelayakanDropzone.manuallyAddFile(file, url);
          // });
        }
      } else if (type == "add") {
        _.resetDokumenKelayakanForm()
        _.dokumenKelayakanDetail = {
          id_kontrak: this.$route.params.id,
          name: '',
          number: '',
          date: '',
          files: [],
          deletedFile: [],
        }
      }
      window.$("#modalDokumenKelayakan").modal("show");
    },
    destroyDokumenKelayakan(x) {
      let _ = this;
      this.$swal
        .fire({
          title: "Hapus Data Ini?",
          text: "Anda mungkin tidak akan mengembalikannya lagi!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#44A8BD",
          cancelButtonColor: "#D95E6A",
          confirmButtonText: "Ya, Hapus!",
          cancelButtonText: "Batal",
        })
        .then((result) => {
          if (result.value) {
            _.axios.delete("v2/document-studies/" + x)
              .then((resp) => {
                if (resp.status) {
                  this.$swal.fire({
                    title: "Terhapus!",
                    text: "Data berhasil dihapus",
                    icon: "success",
                    confirmButtonColor: "#37BA71",
                    confirmButtonText: "OK",
                  });
                  _.getDokumenKelayakan()
                } else {
                  console.log("Failed");
                }
              })
              .catch((err) => {
                console.log(err.response);
              });
          }
        });
    },
    onDokumenKelayakanFilesAdded(file) {
      let _ = this;
      if (file[0].size / 1000000 < _.dokumenKelayakanDropzoneOptions.maxFilesize) {
        $.each(file, function (index, val) {
          _.dokumenKelayakanForm.files.push(val);
        });
      }
    },
    onDokumenKelayakanFilesRemoved(file) {
      let _ = this;
      if (file.lastModified) {
        _.dokumenKelayakanForm.files = ld.filter(
          _.dokumenKelayakanForm.files,
          function (o) {
            return o.name != file.name;
          }
        );
      } else {
        _.dokumenKelayakanForm.deletedFile.push(file.name);
      }
    },
    removeAllDokumenKelayakanFile() {
      let _ = this;
      _.$refs.dokumenKelayakanDropzone.removeAllFiles(true);
      _.dokumenKelayakanForm.files = [];
    },
    resetDokumenKelayakanForm() {
      this.dokumenKelayakanForm = {
        id_kontrak: this.$route.params.id,
        name: '',
        number: '',
        date: '',
        files: [],
        deletedFile: [],
      }
    },
    saveDokumenKelayakan() {
      let _ = this;
      var validation = _.$refs.dokumenKelayakanFormObserver;
      validation.validate()
        .then(async (success) => {
          if (!success) {
            return;
          }
          
          var formData = new FormData();
          $.each(_.dokumenKelayakanForm, function (index, val) {
            if (index == "files") {
              // $.each(_.dokumenKelayakanForm.files, function (index, val) {
              //   formData.append("files[" + index + "]", val);
              // });
              formData.append("file", _.dokumenKelayakanForm.files[0]);
            } else if (index == "deletedFile") {
              $.each(_.dokumenKelayakanForm.deletedFile, function (index, val) {
                formData.append("deletedFile[" + index + "]", val);
              });
            } else {
              formData.append(index, val);
            }
          });

          _.loading = true;

          await _.axios.post("v2/document-studies" + (_.dokumenKelayakanForm.id ? '/' + _.dokumenKelayakanForm.id : ''), formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then(() => {
              _.$toast.success("Dokumen Kajian Kelayakan Berhasil" + (_.dokumenKelayakanForm.id ? ' Diubah' : ' Ditambahkan'))
              _.resetDokumenKelayakanForm()
              _.removeAllDokumenKelayakanFile();
              validation.reset();
              window.$("#modalDokumenKelayakan").modal("hide")
              _.getDokumenKelayakan()
            })
            .catch((err) => {
              console.log(err);
              window.$("#modalDokumenKelayakan").modal("hide")
              _.$toast.warning("Dokumen Kajian Kelayakan Gagal" + (_.dokumenKelayakanForm.id ? ' Diubah' : ' Ditambahkan'));
            });
          _.loading = false;
        });
    },
    pdfViewer(file) {
      // this.$root.$emit('setPDFFile', file);
      this.$emit('showDetail', file);
    },
  },
  mounted() {
    this.getDokumenKelayakan()
  }
}
</script>